import axiosInstance from '../axiosInstance';
import { endpoints } from '../endPoints';

const getDashboardStats = async () => {
  const response = await axiosInstance.get(endpoints.dashboard.getStats);
  const res = response.data;
  if (!res) return null;
  if (res.data !== undefined && res.data !== null) return res;
  if (res.activeStudents !== undefined || res.activeTeachers !== undefined) return { data: res };
  return res;
};

export default {
  getDashboardStats,
};
